import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage(process.env.VUE_APP_SECRET_KEY, {
  prefix: '@data',
  storageType: 'sessionStorage'
});